var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6V19M10 6H5.5C4.83696 6 4.20107 5.73661 3.73223 5.26777C3.26339 4.79893 3 4.16304 3 3.5C3 2.83696 3.26339 2.20107 3.73223 1.73223C4.20107 1.26339 4.83696 1 5.5 1C9 1 10 6 10 6ZM10 6H14.5C15.163 6 15.7989 5.73661 16.2678 5.26777C16.7366 4.79893 17 4.16304 17 3.5C17 2.83696 16.7366 2.20107 16.2678 1.73223C15.7989 1.26339 15.163 1 14.5 1C11 1 10 6 10 6ZM1 12H19M4.2 19H15.8C16.9201 19 17.4802 19 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C19 17.4802 19 16.9201 19 15.8V9.2C19 8.07989 19 7.51984 18.782 7.09202C18.5903 6.71569 18.2843 6.40973 17.908 6.21799C17.4802 6 16.9201 6 15.8 6H4.2C3.0799 6 2.51984 6 2.09202 6.21799C1.71569 6.40973 1.40973 6.71569 1.21799 7.09202C1 7.51984 1 8.07989 1 9.2V15.8C1 16.9201 1 17.4802 1.21799 17.908C1.40973 18.2843 1.71569 18.5903 2.09202 18.782C2.51984 19 3.07989 19 4.2 19Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.25af88aed3f9aef9fe1bc28bbcdd7efc.svg";
export { ForwardRef as ReactComponent };